export const routeErrorBoundaryCopy = {
  title: "This page couldn't load",
  caption: "Something went wrong while showing this page. Try again, or reload to get the latest version.",
  chunkCaption: "A newer version is available. Reload to continue.",
  retry: "Try again",
  reload: "Reload page",
} as const;
